
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index9xoFUrb6z8ViCXCeNO0F0yLqjT1acokPcnKUaARh7yAMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/index.vue?macro=true";
import { default as rulesefy_V6RURHSGdJ0vR07L09IiDQbXxQtZ6i0PLUuT_45gEMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/rules.vue?macro=true";
import { default as levelsqMNESUq3_45_crTMYHC_45cfEkC2gcKJr_YFDPtNizc0f_45MMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/levels.vue?macro=true";
import { default as contactsFZI_wI2HkUzo2hGKKDOgWE7DfpYNQabpVo4KRUTLl_45QMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/contacts.vue?macro=true";
import { default as partnersZmmpjDjJsGvhiIoGSshmJll5lByEotrxyOSWC0ATG1QMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/partners.vue?macro=true";
import { default as indexJX4yAXJHVP_JzLZKWYOjxm3Wa01zfpDR3x5QiwOfWecMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/app/index.vue?macro=true";
import { default as _91id_93b4_fqdFMw7J6Mt_LTxEFF73UhBvdkH2hhEdUKuk_45ilAMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/blog/[id].vue?macro=true";
import { default as companiesEsxeyCYrfpl3NELiPf8EGfaRKZkeR4O6o5fPIDm9qjsMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/companies.vue?macro=true";
import { default as index1fkSlOBndYPf_45QlxcEPTqrqAMBI8uEVGMDAG00ToTiwMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/blog/index.vue?macro=true";
import { default as indexiGLLnRvjKOEmBOzj3Nzh6rOp_45gNgxi_MqOm5qeZBTokMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/en-cy/index.vue?macro=true";
import { default as indexO2ZQFZJagjUomhho954_45K4znDJKLhrr67NxQjuy2OD8Meta } from "/tmp/server_www/app_layers/sportbenefit/pages/en-lt/index.vue?macro=true";
import { default as public_45offerY1mPwBmlyqg1u74Sw3wFsqM1q0E_45AQ_nTz6Ft3bKRnYMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/public-offer.vue?macro=true";
import { default as cookie_45policy2geeKWYSWTuffLwfhNHCgc1HdSClcv62PdPvi3XjRy8Meta } from "/tmp/server_www/app_layers/sportbenefit/pages/cookie-policy.vue?macro=true";
import { default as indexk_458AXqaYLfzy8961uS5USVg9JLECLyszpCjjvsMk6cQMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/facilities/index.vue?macro=true";
import { default as holder_45app_45rulesRX0aG5IzoKYtIZwEs9SBs6EO7U_45Ys7pCJ7OpqIYYc7cMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/holder-app-rules.vue?macro=true";
import { default as indexvB0bdIl0rWifzAHcRhoy3n3jyYFt3ukdeJ0JqGgExzkMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/[documents]/index.vue?macro=true";
import { default as holder_45app_45agreementNzwRENjxtVz1ji_45rfgLUjS708rBymmuA23QH_mFuHxYMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/holder-app-agreement.vue?macro=true";
import { default as index1i62uRWD7JCbQsLD_B90vPY65aTEaU_gr_45_KCffNxscMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/facilities-table/index.vue?macro=true";
import { default as processing_45personal_45dataWOygdYtpM4LZEeHSH6nwuCibTUJdNtjYoN46S11yvMkMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/processing-personal-data.vue?macro=true";
import { default as indexTEjX4Xe2respGXO1TkcIlCc_45mlRr4WUzFexF31E1Ij0Meta } from "/tmp/server_www/app_layers/sportbenefit/pages/[documents]/[document]/index.vue?macro=true";
import { default as providing_45payment_45service_45rulesTmGH1gQjeWAfEZuWWqJFCNdEAfr9wN49B0EyzN_VbAoMeta } from "/tmp/server_www/app_layers/sportbenefit/pages/providing-payment-service-rules.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/index.vue")
  },
  {
    name: "index___en-cy",
    path: "/en-cy",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/index.vue")
  },
  {
    name: "index___en-lt",
    path: "/en-lt",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/index.vue")
  },
  {
    name: "rules___en-cy",
    path: "/en-cy/rules",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/rules.vue")
  },
  {
    name: "rules___en-lt",
    path: "/en-lt/rules",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/rules.vue")
  },
  {
    name: "levels___en-cy",
    path: "/en-cy/levels",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/levels.vue")
  },
  {
    name: "levels___en-lt",
    path: "/en-lt/levels",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/levels.vue")
  },
  {
    name: "contacts___en-cy",
    path: "/en-cy/contacts",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/contacts.vue")
  },
  {
    name: "contacts___en-lt",
    path: "/en-lt/contacts",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/contacts.vue")
  },
  {
    name: "partners___en-cy",
    path: "/en-cy/partners",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/partners.vue")
  },
  {
    name: "partners___en-lt",
    path: "/en-lt/partners",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/partners.vue")
  },
  {
    name: "app___en-cy",
    path: "/en-cy/app",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/app/index.vue")
  },
  {
    name: "app___en-lt",
    path: "/en-lt/app",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/app/index.vue")
  },
  {
    name: "blog-id___en-cy",
    path: "/en-cy/blog/:id()",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/blog/[id].vue")
  },
  {
    name: "blog-id___en-lt",
    path: "/en-lt/blog/:id()",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/blog/[id].vue")
  },
  {
    name: "companies___en-cy",
    path: "/en-cy/companies",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/companies.vue")
  },
  {
    name: "companies___en-lt",
    path: "/en-lt/companies",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/companies.vue")
  },
  {
    name: "blog___en-cy",
    path: "/en-cy/blog",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/blog/index.vue")
  },
  {
    name: "blog___en-lt",
    path: "/en-lt/blog",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/blog/index.vue")
  },
  {
    name: "en-cy___en-cy",
    path: "/en-cy/en-cy",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/en-cy/index.vue")
  },
  {
    name: "en-cy___en-lt",
    path: "/en-lt/en-cy",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/en-cy/index.vue")
  },
  {
    name: "en-lt___en-cy",
    path: "/en-cy/en-lt",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/en-lt/index.vue")
  },
  {
    name: "en-lt___en-lt",
    path: "/en-lt/en-lt",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/en-lt/index.vue")
  },
  {
    name: "public-offer___en-cy",
    path: "/en-cy/public-offer",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/public-offer.vue")
  },
  {
    name: "public-offer___en-lt",
    path: "/en-lt/public-offer",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/public-offer.vue")
  },
  {
    name: "cookie-policy___en-cy",
    path: "/en-cy/cookie-policy",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___en-lt",
    path: "/en-lt/cookie-policy",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/cookie-policy.vue")
  },
  {
    name: "facilities___en-cy",
    path: "/en-cy/facilities",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/facilities/index.vue")
  },
  {
    name: "facilities___en-lt",
    path: "/en-lt/facilities",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/facilities/index.vue")
  },
  {
    name: "holder-app-rules___en-cy",
    path: "/en-cy/holder-app-rules",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/holder-app-rules.vue")
  },
  {
    name: "holder-app-rules___en-lt",
    path: "/en-lt/holder-app-rules",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/holder-app-rules.vue")
  },
  {
    name: "documents___en-cy",
    path: "/en-cy/:documents()",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/[documents]/index.vue")
  },
  {
    name: "documents___en-lt",
    path: "/en-lt/:documents()",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/[documents]/index.vue")
  },
  {
    name: "holder-app-agreement___en-cy",
    path: "/en-cy/holder-app-agreement",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/holder-app-agreement.vue")
  },
  {
    name: "holder-app-agreement___en-lt",
    path: "/en-lt/holder-app-agreement",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/holder-app-agreement.vue")
  },
  {
    name: "facilities-table___en-cy",
    path: "/en-cy/facilities-table",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/facilities-table/index.vue")
  },
  {
    name: "facilities-table___en-lt",
    path: "/en-lt/facilities-table",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/facilities-table/index.vue")
  },
  {
    name: "processing-personal-data___en-cy",
    path: "/en-cy/processing-personal-data",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/processing-personal-data.vue")
  },
  {
    name: "processing-personal-data___en-lt",
    path: "/en-lt/processing-personal-data",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/processing-personal-data.vue")
  },
  {
    name: "documents-document___en-cy",
    path: "/en-cy/:documents()/:document()",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/[documents]/[document]/index.vue")
  },
  {
    name: "documents-document___en-lt",
    path: "/en-lt/:documents()/:document()",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/[documents]/[document]/index.vue")
  },
  {
    name: "providing-payment-service-rules___en-cy",
    path: "/en-cy/providing-payment-service-rules",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/providing-payment-service-rules.vue")
  },
  {
    name: "providing-payment-service-rules___en-lt",
    path: "/en-lt/providing-payment-service-rules",
    component: () => import("/tmp/server_www/app_layers/sportbenefit/pages/providing-payment-service-rules.vue")
  }
]